import { Injectable } from '@angular/core';
import { ApplicationBase } from '../../../shared/application/ApplicationBase';
import { LoginRepository } from '../domain/login.repository';
import { LoginDto } from '../domain/login_dto.entity';

@Injectable()
export class LoginApp extends ApplicationBase {
  constructor(private loginRepository: LoginRepository) {
    super();
  }
  public getVersion(): Promise<string> {
    return this.loginRepository.getVersion();
  }

  public async login(data: LoginDto): Promise<string> {
    data.code =
      localStorage.getItem(`${data.username}-sessioncode`.toLowerCase()) ?? '';
    let result = await this.loginRepository.login(data);
    if (result.startsWith('login-'))
      sessionStorage.setItem('sessionToken', result.replaceAll('login-', ''));
    else sessionStorage.setItem('sessionToken', result);
    return result;
  }

  public recover(username: string): Promise<boolean> {
    return this.loginRepository.recover(username);
  }

  public recoverChangePassword(
    id: string,
    code: string,
    password: string
  ): Promise<string> {
    return this.loginRepository.recoverChangePassword(id, code, password);
  }

  public getUser(): Promise<any> {
    return this.loginRepository.getUser();
  }

  public async renewToken(): Promise<string> {
    try {
      let result = await this.loginRepository.renewToken();
      sessionStorage.setItem('sessionToken', result);
      return result;
    } catch (erro) {
      console.error('renew token error');
      return '';
    }
  }

  public async logout(): Promise<boolean> {
    sessionStorage.removeItem('sessionToken');
    let result = await this.loginRepository.logout();
    return result;
  }

  public async validateLinkNewMail(id: string, code: string): Promise<string> {
    sessionStorage.removeItem('sessionToken');
    let result = await this.loginRepository.validateLinkNewMail(id, code);
    sessionStorage.setItem('sessionToken', result);
    return result;
  }

  public validateLinkRecovery(id: string, code: string): Promise<boolean> {
    return this.loginRepository.validateLinkRecovery(id, code);
  }

  public getSessionCode(): Promise<string | null> {
    return this.loginRepository.getSessionCode();
  }

  public reSendCode(id: string): Promise<boolean> {
    return this.loginRepository.reSendCode(id);
  }
}
